
// 公共方法及过滤器等
export const funcs = {
	getLabelByCode(value: string, dictArr: any[],origin:boolean=true) {
		if (!value || ['','null','undefined'].includes(value)) return;
		return dictArr?.find((dict) => dict.value+'' === value)?.label || (origin?value:'');
	},
};
export default {
	install: (Vue: any) => {
		// 字典过滤器
		Vue.filter('formatCode', funcs.getLabelByCode);
	},
};
